 import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Chip,
  Container,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  styled,
  Tabs, 
  Tab
} from '@mui/material';
import {
  Close,
  Description,
  Download,
  Print
} from '@mui/icons-material';

import CierreCaso from './CierreCaso';
import NuevoAvance from './NuevoAvance';
import HistorialAvances from './HistorialAvances';

import { Visibility, ExpandMore, Lock } from '@mui/icons-material';
import { ContextSession } from "../../services/ContextSession";
import ImpresionDemandas from './ImpresionDemandas';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  width: '50%',
  borderRight: '1px solid rgba(224, 224, 224, 1)',
  fontWeight: 'bold'
}));
const AccionesDemandaPage = () => {
  let sessi = useContext(ContextSession);
  let demandaId = sessi.getVariable("demandaID");
  const navigate = useNavigate();

  // Estados principales
  const [demanda, setDemanda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [avances, setAvances] = useState([]);
  const [adjuntos, setAdjuntos] = useState([]);
  const [loadingAvances, setLoadingAvances] = useState(false);
  
  // Estados para nuevo avance
  const [nuevoAvance, setNuevoAvance] = useState({ descripcion: '', archivos: [] });
  const [showCierreDialog, setShowCierreDialog] = useState(false);
  const [submittingAvance, setSubmittingAvance] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  
  // Estados para UI
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  
  const [showAdjuntos, setShowAdjuntos] = useState(false);
  const [descargandoId, setDescargandoId] = useState(null);
  const [previewFile, setPreviewFile] = useState({
    open: false,
    base64: '',
    nombre: '',
    tipo: '',
    loading: false
  });

  const [dataProcuradores, setDataProcuradores] = useState([]);
  const [procuradoresMap, setProcuradoresMap] = useState({});
 
   const normalizarFecha = (fechaStr, opciones = {}) => {
  if (!fechaStr) return 'No disponible';
  
  let fecha;
  
  try {
    if (fechaStr.includes(' ')) {
      fecha = new Date(fechaStr.replace(' ', 'T') + 'Z');
    } else {
      fecha = new Date(fechaStr);
    }
    
    if (isNaN(fecha.getTime())) {
      return 'Fecha inválida';
    }
    
    return new Intl.DateTimeFormat('es-HN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(fecha);
    
  } catch (error) {
    console.error('Error formateando fecha:', error);
    return 'Fecha inválida';
  }
};

  // Función para obtener información del procurador
  const getProcuradorInfo = (procuradorAsignado) => {
    let procuradorInfo = null;
    if (procuradorAsignado) {
      if (isNaN(procuradorAsignado)) {
        procuradorInfo = { nombre: procuradorAsignado };
      } else {
        const procuradorId = parseInt(procuradorAsignado);
        procuradorInfo = dataProcuradores.find(p => p.id === procuradorId) || null;
      }
    }
    return procuradorInfo;
  };

  // Función para obtener el nombre del procurador
  const getProcuradorNombre = (procuradorAsignado) => {
    const procuradorInfo = getProcuradorInfo(procuradorAsignado);
    return procuradorInfo ? procuradorInfo.nombre : 'No asignado';
  };

  // Cargar procuradores
  useEffect(() => {
    const fetchProcuradores = async () => {
      try {
        const token = sessi.sessionData.token;
        const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/auth/oficialesLegal/', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        setDataProcuradores(data);
        
        // Crear mapa de procuradores por ID
        const map = data.reduce((acc, procurador) => {
          acc[procurador.id] = procurador;
          return acc;
        }, {});
        setProcuradoresMap(map);
        
      } catch (error) {
        console.error("Error al cargar procuradores:", error);
        setSnackbar({
          open: true,
          message: 'Error al cargar la lista de procuradores',
          severity: 'error'
        });
      }
    };

    fetchProcuradores();
  }, [sessi.sessionData.token]);

  // Obtener datos de la demanda
  useEffect(() => {
    const fetchDemanda = async () => {
      try {
        setLoading(true);
        const token = sessi.sessionData.token;

        // Obtener demanda por ID 
        const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/tramite/${demandaId}/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }

        const demandaData = await response.json();

        if (!demandaData) {
          throw new Error("La demanda no existe o la estructura de datos es incorrecta");
        }

        console.log('Datos de demanda recibidos:', demandaData);
          // Obtener nombre del procurador
        const procuradorInfo = getProcuradorInfo(demandaData.procuradorasignado);
        const procuradorNombre = procuradorInfo ? procuradorInfo.nombre : 'No asignado';

        // Determinar el nombre del demandante basado en la naturaleza
        let nombreDemandante = '';
        if (demandaData.naturaleza === 1) { // A Favor
          nombreDemandante = demandaData.nombredemandante || 'N/A';
        } else if (demandaData.naturaleza === 2) { // En Contra
          nombreDemandante = demandaData.nombredemandado || 'N/A';
        }

        // Procesar datos de la demanda según la nueva estructura
        const demandaProcesada = {
          ...demandaData,
          // Mapeo de campos según la nueva API
          tramiteid: demandaData.id || demandaId,
          numerodemanda: demandaData.numerodemanda || 'No disponible', 
          numeroexpediente: demandaData.numeroexpediente || 'No disponible',
          fechapresentacion: demandaData.fechapresentacion,
          naturaleza: demandaData.naturaleza,
          nombredemandado: demandaData.nombredemandado,
          nombredemandante: demandaData.nombredemandante,
          tipodemandante: demandaData.tipodemandante,
          tipodemanda: demandaData.tipodemanda,
          motivodemanda: demandaData.motivodemanda || 'No disponible',
          estado: demandaData.estado || 'No definido',
          procuradorasignado: procuradorNombre, // Usar el nombre en lugar del ID
          procuradorInfo: procuradorInfo, // Guardar info completa del procurador
          juzgado: demandaData.juzgado || 'No especificada',
          moneda: demandaData.moneda,
          tipocambio: demandaData.tipocambio,
          montoestimacion: demandaData.montoestimacion,
          cuentaestimacion: demandaData.cuentaestimacion,
          cuentaprovision: demandaData.cuentaprovision,
          cuentagastos: demandaData.cuentagastos,
          riesgocredito: demandaData.riesgocredito,
          observaciones: demandaData.observaciones,
          accioninstitucion: demandaData.accioninstitucion,
          resultadoprimerainstancia: demandaData.resultadoprimerainstancia,
          resultadosegundainstancia: demandaData.resultadosegundainstancia,
          fechaactuacion: demandaData.fechaactuacion,
          fechamaximacontestacion: demandaData.fechamaximacontestacion || null,
          montogastoslegales: demandaData.montogastoslegales,
          montodemandado: demandaData.montodemandado,
          montoprovision: demandaData.montoprovision,
          valordefinitivoconciliado: demandaData.valordefinitivoconciliado,
          cuentavalordefinitivo: demandaData.cuentavalordefinitivo,
          resultadocierre: demandaData.resultadocierre,
          descripcioncierre: demandaData.descripcioncierre,
        };

        setDemanda(demandaProcesada);
        await fetchAvancesYAdjuntos(demandaId);

      } catch (err) {
        console.error("Error al cargar la demanda:", err);
        setError(err.message || "Error desconocido al cargar la demanda");
      } finally {
        setLoading(false);
      }
    };

    fetchDemanda();
  }, [demandaId, sessi.sessionData.token, dataProcuradores]);


  const fetchAvancesYAdjuntos = async (id) => {
  try {
    setLoadingAvances(true);
    const token = sessi.sessionData.token;
  
    const [avancesRes, adjuntosRes] = await Promise.all([
      fetch(`https://bei360.injupemp.gob.hn:8444/api/tramite-avance/listar/${id}/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      }),
      fetch(`https://bei360.injupemp.gob.hn:8444/api/adjuntos/listar/?entity_id=${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })
    ]);
    
    // VERIFICAR SI LAS RESPUESTAS SON OK
    if (!avancesRes.ok) {
      throw new Error(`Error al cargar avances: ${avancesRes.status}`);
    }
    
    if (!adjuntosRes.ok) {
      throw new Error(`Error al cargar adjuntos: ${adjuntosRes.status}`);
    }
    
    const avancesData = await avancesRes.json();
    const adjuntosData = await adjuntosRes.json();
    
    console.log(' Avances cargados:', avancesData);
    console.log(' Adjuntos cargados:', adjuntosData);
    
    // Ordenar por fecha (más reciente primero)
    setAvances(avancesData.sort((a, b) => 
      new Date(b.fechaavance) - new Date(a.fechaavance) // Cambiado para orden descendente
    ));
    setAdjuntos((adjuntosData.adjuntos || []).sort((a, b) => 
      new Date(b.fecha) - new Date(a.fecha) // Cambiado para orden descendente
    ));
  } catch (err) {
    console.error('Error al cargar avances o adjuntos:', err);
    setSnackbar({
      open: true,
      message: `Error al cargar avances o adjuntos: ${err.message}`,
      severity: 'error'
    });
  } finally {
    setLoadingAvances(false);
  }
};

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
 
  const handleAvanceChange = (e) => {
    const { name, value } = e.target;
    setNuevoAvance(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setNuevoAvance(prev => ({
      ...prev,
      archivos: [...(prev.archivos || []), ...files] 
    }));
  };

  const handleRemoveArchivo = (indexToRemove) => {
    setNuevoAvance(prev => ({
      ...prev,
      archivos: prev.archivos.filter((_, i) => i !== indexToRemove)
    }));
  };

  const handleSubmitAvance = async (e) => {
    e.preventDefault();
    setSubmittingAvance(true);

    try {
      const token = sessi.sessionData.token;
      const usuarioId = sessi.sessionData.id;
      const usuarioNombre = `${sessi.sessionData.nombre || ''} ${sessi.sessionData.apellido || ''}`.trim();
      
      // Crear el avance
      const avanceData = {
        tramiteid: demandaId,
        descripcionavance: nuevoAvance.descripcion,
        usuarioid: usuarioId,
        usuarionombre: usuarioNombre || sessi.sessionData.username
      };

      const avanceResponse = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramite-avance/crear/', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(avanceData)
      });

      if (!avanceResponse.ok) {
        throw new Error('Error al crear el avance');
      }

      // Subir archivos uno por uno si existen
      if (nuevoAvance.archivos && nuevoAvance.archivos.length > 0) {
        const uploadPromises = nuevoAvance.archivos.map(async (archivo) => {
          const formData = new FormData();
          formData.append('archivo', archivo);
          formData.append('entity_id', demandaId);
          formData.append('usuario_id', usuarioId);
          formData.append('usuario_nombre', usuarioNombre || sessi.sessionData.username);

          const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/adjuntos/subir/', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            },
            body: formData
          });

          if (!response.ok) {
            const errorData = await response.json();
            console.error('Error al subir adjunto:', errorData);
            throw new Error(errorData?.detail || 'Error al subir adjunto');
          }

          return response.json();
        });

        await Promise.all(uploadPromises);
      }

      // Mostrar éxito y actualizar
      setSnackbar({
        open: true,
        message: 'Avance creado exitosamente',
        severity: 'success'
      });

      // Limpiar formulario y recargar datos
      setNuevoAvance({ descripcion: '', archivos: [] });
      await fetchAvancesYAdjuntos(demandaId);

    } catch (error) {
      console.error('Error general:', error);
      setSnackbar({
        open: true,
        message: error.message || 'Error al procesar el avance',
        severity: 'error'
      });
    } finally {
      setSubmittingAvance(false);
    }
  };

 const getAdjuntosRelacionados = (avance) => {
  const MARGEN_10_SEGUNDOS = 10 * 1000;
  
  console.log('=== getAdjuntosRelacionados llamado ===');
  
  // Si no hay adjuntos, retorna array vacío
  if (!adjuntos || adjuntos.length === 0) {
    console.log('No hay adjuntos cargados aún');
    return [];
  }
  
  const relacionados = adjuntos.filter(adj => {
    try {
      console.log('Comparando:', {
        adjId: adj.id,
        adjUsuario: adj.usuario_id,
        adjFecha: adj.fecha,
        avanceUsuario: avance.usuarioid,
        avanceFecha: avance.fechaavance
      });
      
      // Verificar usuario
      const usuariosIguales = adj.usuario_id == avance.usuarioid;
      
      if (!usuariosIguales) {
        console.log('Usuarios diferentes');
        return false;
      }
      
      // FUNCIÓN CORREGIDA PARA PARSEAR FECHAS
      const parsearFecha = (fechaStr) => {
        if (!fechaStr) return null;
        
        // Si ya es un objeto Date
        if (fechaStr instanceof Date) return fechaStr;
        
        // Para formato con espacio: "2026-01-14 10:13:50"
        if (fechaStr.includes(' ')) {
          // CAMBIO: NO añadir 'Z', dejar que Date lo interprete como hora local
          return new Date(fechaStr.replace(' ', 'T'));
        }
        
        // Para formato ISO: "2026-01-14T10:13:48.957000"
        return new Date(fechaStr);
      };
      
      const fechaAdjunto = parsearFecha(adj.fecha);
      const fechaAvance = parsearFecha(avance.fechaavance);
      
      if (!fechaAdjunto || !fechaAvance) {
        console.log('Fechas inválidas');
        return false;
      }
      
      // Verificar que son fechas válidas
      if (isNaN(fechaAdjunto.getTime()) || isNaN(fechaAvance.getTime())) {
        console.log('Fechas NaN');
        return false;
      }
      
      const diferencia = Math.abs(fechaAdjunto.getTime() - fechaAvance.getTime());
      const dentroMargen = diferencia <= MARGEN_10_SEGUNDOS;
      
      console.log('Resultado:', {
        fechaAdjunto: fechaAdjunto.toISOString(),
        fechaAvance: fechaAvance.toISOString(),
        fechaAdjuntoLocal: fechaAdjunto.toLocaleString('es-HN'),
        fechaAvanceLocal: fechaAvance.toLocaleString('es-HN'),
        diferenciaMs: diferencia,
        dentroMargen: dentroMargen,
        usuariosIguales: usuariosIguales
      });
      
      return dentroMargen;
      
    } catch (error) {
      console.error('Error:', error);
      return false;
    }
  });
  
  console.log('Adjuntos relacionados encontrados:', relacionados);
  return relacionados;
};
  
  // Obtener archivo en base64
  const fetchAdjuntoBase64 = async (adjuntoId) => {
    try {
      const token = sessi.sessionData.token;
      const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/adjuntos/base64?id=${adjuntoId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.base64 || !data.nombre || !data.tipo_archivo) {
        console.error('Estructura de respuesta inesperada:', data);
        throw new Error('La respuesta del servidor no tiene el formato esperado');
      }
      
      return {
        base64: data.base64,
        nombreArchivo: data.nombre,
        tipoArchivo: data.tipo_archivo,
        id: data.id
      };
    } catch (error) {
      console.error('Error obteniendo archivo en base64:', error);
      throw new Error(`No se pudo obtener el archivo: ${error.message}`);
    }
  };

  // Descargar adjunto
  const handleDescargarAdjunto = async (adjuntoId, nombreArchivoDefault = '') => {
    try {
      setDescargandoId(adjuntoId);
      
      const archivo = await fetchAdjuntoBase64(adjuntoId);
      
      const link = document.createElement('a');
      link.href = `data:${archivo.tipoArchivo};base64,${archivo.base64}`;
      link.download = archivo.nombreArchivo || nombreArchivoDefault || `adjunto_${adjuntoId}`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setSnackbar({
        open: true,
        message: `Descarga iniciada: ${archivo.nombreArchivo}`,
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Error al descargar el archivo',
        severity: 'error'
      });
    } finally {
      setDescargandoId(null);
    }
  };

  // Vista previa de archivo
  const handlePreview = async (adjuntoId, nombreArchivo) => {
    try {
      setPreviewFile(prev => ({
        ...prev,
        open: true,
        loading: true,
        nombre: nombreArchivo
      }));
      
      const archivo = await fetchAdjuntoBase64(adjuntoId);
      
      setPreviewFile({
        open: true,
        base64: archivo.base64,
        nombre: archivo.nombreArchivo,
        tipo: archivo.tipoArchivo,
        loading: false,
        id: adjuntoId
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Error al cargar el archivo para vista previa',
        severity: 'error'
      });
      setPreviewFile(prev => ({ ...prev, open: false }));
    }
  };

  const handleClearAvance = () => {
    setNuevoAvance({ descripcion: '', archivos: null });
  };

  // Cerrar vista previa
  const handleClosePreview = () => {
    setPreviewFile(prev => ({ ...prev, open: false }));
  };


   const handleImprimirTramite = () => {
    if (!demanda) {
      setSnackbar({
        open: true,
        message: 'No hay datos de la demanda para imprimir',
        severity: 'warning'
      });
      return;
    }

    try {
      // Usar la clase base para generar el PDF
      const impresor = new ImpresionDemandas(demanda);
      impresor.generarPDF();
      
      setSnackbar({
        open: true,
        message: 'PDF generado exitosamente',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error al generar PDF:', error);
      setSnackbar({
        open: true,
        message: 'Error al generar el PDF',
        severity: 'error'
      });
    }
  };
  // Cerrar snackbar
  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  // Renderizado condicional mientras carga
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4}>
        <Alert severity="error">{error}</Alert>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Volver
        </Button>
      </Box>
    );
  }

return (
  <Container maxWidth="xl" style={{ marginTop: '2rem', padding: '1rem', borderRadius: '8px' }}>
    {/* Encabezado con datos de la demanda */}
    <Paper elevation={3} style={{ padding: '1rem', backgroundColor: '#f0f0f0', marginBottom: '2rem' }}>
      <Typography variant="h5" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        Datos de la demanda #{demandaId}
      </Typography>
      
      <Paper sx={{ maxWidth: 1250, margin: '0 auto', mb: 3 }}>
        {/* Tabs centrados */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            centered
          sx={{
            '& .MuiTabs-flexContainer': {
              justifyContent: 'center'
            },
            '& .MuiTabs-indicator': {
              display: 'none' // Esto elimina completamente el indicador
            }
          }}
          >
            <Tab label="Información General" />
            <Tab label="Detalles Legales" />
            <Tab label="Información Financiera" />
            <Tab label="Resultados" />
            <Tab label="Documentos" />
          </Tabs>
        </Box>
        
        {/* Contenido de los tabs - Tabla con ancho completo */}
        <TableContainer>
          <Table sx={{ minWidth: 1000 }}> 
            <TableBody>
              {/* Pestaña 1: Información General */}
              {tabValue === 0 && (
                <>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>No. Demanda:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '400' }}>{demanda?.numerodemanda || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50', fontWeight: 'bold' }}>No. Expediente:</StyledTableCell>
                    <TableCell sx={{ width: '50', fontWeight: '300' }}>{demanda?.numeroexpediente || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Fecha Presentación:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.fechapresentacion || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Naturaleza:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      {demanda?.naturaleza === 1 ? 'A Favor' : 
                       demanda?.naturaleza === 2 ? 'En Contra' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Demandado:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.nombredemandado || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Demandante:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.nombredemandante || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Tipo de Demandante:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      {demanda?.tipodemandante === 1 ? 'Persona Natural' : 
                       demanda?.tipodemandante === 2 ? 'Persona Jurídica' : 
                       demanda?.tipodemandante === 3 ? 'Proveedor' : 
                       demanda?.tipodemandante === 4 ? 'Colaborador' : 
                       demanda?.tipodemandante === 5 ? 'Otros' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Estado:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      <Chip 
                        label={demanda?.estado?.toUpperCase()} 
                        color={ 
                          demanda?.estado?.toLowerCase() === 'cerrado' ? 'warning' : 
                          demanda?.estado?.toLowerCase() === 'en proceso' ? 'primary' : 'success' 
                        } 
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Observaciones:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.observaciones || 'No disponible'}</TableCell>
                  </TableRow>
                </>
              )}
              
              {/* Pestaña 2: Detalles Legales */}
              {tabValue === 1 && (
                <>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Tipo de Demanda:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      {demanda?.tipodemanda === 1 ? 'Daños y Perjuicios' : 
                       demanda?.tipodemanda === 2 ? 'Ejecución de Garantías' : 
                       demanda?.tipodemanda === 3 ? 'Ejecución de Pagos' : 
                       demanda?.tipodemanda === 4 ? 'Ejecución de Títulos' : 
                       demanda?.tipodemanda === 5 ? 'Ejecutiva' : 
                       demanda?.tipodemanda === 6 ? 'Extra Contractual' : 
                       demanda?.tipodemanda === 7 ? 'Laboral' : 
                       demanda?.tipodemanda === 8 ? 'Monitorio' : 
                       demanda?.tipodemanda === 9 ? 'Nulidad de Instrumentos' : 
                       demanda?.tipodemanda === 10 ? 'Responsabilidad Contractual' : 
                       demanda?.tipodemanda === 11 ? 'Otros' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Motivo de demanda:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.motivodemanda || 'No disponible'}</TableCell>
                  </TableRow>
                 <TableRow>
                      <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Procurador asignado:</StyledTableCell>
                      <TableCell sx={{ width: '50%' }}>
                        {getProcuradorNombre(demanda?.procuradorasignado)}
                      </TableCell>
                    </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Juzgado:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      {demanda?.juzgado === 1 ? 'Juzgado Civil' : 
                       demanda?.juzgado === 2 ? 'Juzgado Primero de Letras Departamental' : 
                       demanda?.juzgado === 3 ? 'Juzgado Primero de Letras Seccional' : 
                       demanda?.juzgado === 4 ? 'Ministerio Público' : 
                       demanda?.juzgado === 5 ? 'Otros' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Fecha de Actuación:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.fechaactuacion || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Fecha máxima Contestación:</StyledTableCell>
                   <TableCell sx={{ width: '50%', fontWeight: '300' }}>{demanda?.fechamaximacontestacion || 'No disponible'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Acción de la Institución:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>
                      {demanda?.accioninstitucion || 'No disponible'}
                    </TableCell>
                  </TableRow>
                </>
              )}
              
              {/* Pestaña 3: Información Financiera */}
              {tabValue === 2 && (
                <>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Tipo de Moneda:</StyledTableCell>
                    <TableCell sx={{ width: '50%' }}>
                      {demanda?.moneda === 1 ? 'Lempiras (HNL)' : 
                       demanda?.moneda === 2 ? 'Dólares (USD)' : 
                       demanda?.moneda === 3 ? 'Euros (EUR)' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Tipo de Cambio:</StyledTableCell>
                    <TableCell sx={{ width: '65%' }}>{demanda?.tipocambio || 'No asignado'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Monto de estimación:</StyledTableCell>
                    <TableCell sx={{ width: '65%' }}>
                      {demanda?.montoestimacion ? 
                       `L. ${parseFloat(demanda.montoestimacion).toLocaleString('es-HN')}` : 'No definido'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Cuenta Estimación:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.cuentaestimacion || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Cuenta Provisión:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.cuentaprovision || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Cuenta Gastos:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.cuentagastos || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Riesgo de credito:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.riesgocredito === 1 ? 'Si' : 
                       demanda?.riesgocredito === 2 ? 'No' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Monto gastos legales:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.montogastoslegales || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Monto Demandado:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.montodemandado || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Monto Provisión:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.montoprovision || 'No disponible'}
                    </TableCell>
                  </TableRow>
                </>
              )}
              
              {/* Pestaña 4: Resultados */}
              {tabValue === 3 && (
                <>
                  <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Resultado Primera Instancia:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>
                      {demanda?.resultadoprimerainstancia === 1 ? 'Favorable' : 
                       demanda?.resultadoprimerainstancia === 2 ? 'Desfavorable' : 
                       demanda?.resultadoprimerainstancia === 3 ? 'No aplica' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Resultado Segunda Instancia:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.resultadosegundainstancia === 1 ? 'Favorable' : 
                       demanda?.resultadosegundainstancia === 2 ? 'Desfavorable' : 
                       demanda?.resultadosegundainstancia === 3 ? 'No aplica' : 'No definida'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Valor Definitivo Conciliado:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.valordefinitivoconciliado || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Cuenta Valor Definitivo:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.cuentavalordefinitivo || 'No disponible'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ width: '35%', fontWeight: 'bold', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                      Resultado de la Demanda:
                    </TableCell>
                    <TableCell sx={{ width: '65%' }}>
                      {demanda?.resultadocierre === 1 ? 'Favorable' : 
                       demanda?.resultadocierre === 2 ? 'Desfavorable' : 
                       demanda?.resultadocierre === 3 ? 'Conciliación' : 
                       demanda?.resultadocierre === 4 ? 'Proceso desistido o abandono de proceso' : 
                       demanda?.resultadocierre === 5 ? 'Otros' : 'No definida'}
                    </TableCell>
                  </TableRow>

                   <TableRow>
                    <StyledTableCell sx={{ width: '50%', fontWeight: 'bold' }}>Fecha de finalización de la demanda:</StyledTableCell>
                    <TableCell sx={{ width: '50%', fontWeight: '300' }}>{normalizarFecha(demanda?.fechacierre || 'No disponible')}</TableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell sx={{ width: '35%', fontWeight: 'bold' }}>Descripción Cierre:</StyledTableCell>
                    <TableCell sx={{ width: '65%', fontWeight: '300' }}>
                      {demanda?.descripcioncierre || 'No disponible'}
                    </TableCell>
                  </TableRow>
                </>
              )}
              
              {/* Pestaña 5: Documentos */}
          {tabValue === 4 && (
            <TableRow>
              <TableCell colSpan={2} sx={{ padding: 0 }}>
                <Box sx={{ p: 3 }}>
                  <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
                    Documentos Adjuntos ({adjuntos.length})
                  </Typography>
                  {adjuntos.length > 0 ? (
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: 1, 
                      maxHeight: '400px', 
                      overflowY: 'auto' 
                    }}>
                      {adjuntos.map((adjunto) => (
                        <Paper 
                          key={adjunto.id} 
                          elevation={1} 
                          sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 2, 
                            p: 2, 
                            '&:hover': { backgroundColor: '#f5f5f5' } 
                          }}
                        >
                          <Description fontSize="medium" color="primary" />
                          <Box sx={{ flexGrow: 1 }}>
                            {/* Leyenda con nombre del archivo y usuario */}
                            <Typography variant="body1" sx={{ fontWeight: '500' }}>
                              {adjunto.nombre}
                            </Typography>
                            <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                              Subido por: {adjunto.usuario_nombre || 'Usuario no disponible'}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip title="Vista previa">
                              <IconButton 
                                size="medium" 
                                onClick={() => handlePreview(adjunto.id, adjunto.nombre_archivo)}
                                color="primary"
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Descargar">
                              <IconButton 
                                size="medium" 
                                onClick={() => handleDescargarAdjunto(adjunto.id, adjunto.nombre_archivo)}
                                color="success"
                              >
                                <Download />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Paper>
                      ))}
                    </Box>
                  ) : (
                    <Typography 
                      variant="body1" 
                      color="textSecondary" 
                      sx={{ textAlign: 'center', py: 4 }}
                    >
                      No hay documentos adjuntos
                    </Typography>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          )}
            </TableBody>
          </Table>
        </TableContainer>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center', 
          p: 2, 
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#fafafa'
        }}>
          <Button 
            variant="contained" 
            startIcon={<Print />} 
            onClick={handleImprimirTramite} 
            color="success"
            sx={{ minWidth: 150 }}
          >
            Imprimir PDF
          </Button>
        </Box>
      </Paper>
    </Paper>

    {/* Componente para nuevo avance (solo si no está cerrado) */}
    {demanda?.estado?.toLowerCase() !== 'cerrado' && (
      <NuevoAvance
        nuevoAvance={nuevoAvance}
        handleAvanceChange={handleAvanceChange}
        handleFileChange={handleFileChange}
        handleSubmitAvance={handleSubmitAvance}
        submittingAvance={submittingAvance}
        handleClearAvance={handleClearAvance}
        handleRemoveArchivo={handleRemoveArchivo}
      />
    )}

    {/* Componente de Historial de Avances */}
    <HistorialAvances
      avances={avances}
      loadingAvances={loadingAvances}
      showAdjuntos={showAdjuntos}
      setShowAdjuntos={setShowAdjuntos}
      handlePreview={handlePreview}
      getAdjuntosRelacionados={getAdjuntosRelacionados}
      handleDescargarAdjunto={handleDescargarAdjunto}
      descargandoId={descargandoId}
      handleClearAvance={handleClearAvance}
    />

   {/* Botón de cierre de caso (solo si no está cerrado) */}
    {!['cerrado', 'creada'].includes(demanda?.estado?.toLowerCase()?.trim()) && (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        py: 2 
      }}>
        <Button
          variant="contained"
          sx={{
            minWidth: 100,
            height: 45,
            backgroundColor: '#FF0000',
            '&:hover': {
              backgroundColor: '#CC0000',
            },
            color: 'white',
            fontWeight: 'bold',
          }}
          startIcon={<Lock />}
          onClick={() => setShowCierreDialog(true)}
        >
          Cerrar Demanda
        </Button>
      </Box>
    )}

    {/* Diálogo de cierre de caso */}
    <CierreCaso 
      open={showCierreDialog}
      demandaId={demandaId}
      onClose={() => setShowCierreDialog(false)}
      onSuccess={() => {
        setSnackbar({
          open: true,
          message: "El caso ha sido cerrado exitosamente", 
          severity: 'success'
        });
        fetchAvancesYAdjuntos(demandaId);
      }}
      setDemanda={setDemanda}
      estadoActual={demanda?.estado}
      avances={avances}
      setAvances={setAvances}
      setEstadoActual={(estado) => setDemanda(prev => ({ ...prev, estado }))}
    />

    {/* Snackbar para mensajes */}
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleCloseSnackbar}
        severity={snackbar.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>

    {/* Diálogo para vista previa de archivo */}
    <Dialog
      open={previewFile.open}
      onClose={handleClosePreview}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">
            {previewFile.nombre || 'Archivo sin nombre'}
            {previewFile.id && ` (ID: ${previewFile.id})`}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClosePreview}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {previewFile.loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Cargando vista previa...</Typography>
          </Box>
        ) : (
          <>
            {previewFile.tipo.startsWith('image/') ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', maxHeight: '50vh', overflow: 'auto', mt: 2 }}>
                <img 
                  src={`data:${previewFile.tipo};base64,${previewFile.base64}`} 
                  alt={previewFile.nombre}
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                />
              </Box>
            ) : previewFile.tipo === 'application/pdf' ? (
              <iframe 
                src={`data:${previewFile.tipo};base64,${previewFile.base64}`}
                title={previewFile.nombre}
                style={{ width: '100%', height: '500px', border: 'none', marginTop: '16px' }}
              />
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Description sx={{ fontSize: 60, color: 'text.secondary' }} />
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Vista previa no disponible
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Este tipo de archivo no puede mostrarse en vista previa.
                </Typography>
              </Box>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
         <Button 
          onClick={handleClosePreview}
          startIcon={<Close />}
          color="error"
        >
          Cerrar
        </Button>
        <Button 
          onClick={() => handleDescargarAdjunto(previewFile.id, previewFile.nombre)}
          startIcon={<Download />}
          variant="contained"
        >
          Descargar
        </Button>
      </DialogActions>
    </Dialog>
  </Container>
);
};

export default AccionesDemandaPage;